import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  try {
    // If we don't have a usable token + user session, redirect to welcome/login.
    if (!authService.hasUsableClientSession()) {
      authService.clearClientAuthStateWithoutServerCall();
      void router.navigateByUrl("/welcome", { replaceUrl: true });
      return false;
    }

    const user = authService.getLoggedInUser();

    // Role-based route access
    if (
      user.type === "NURSE" &&
      (state.url.startsWith("/admin") || state.url.startsWith("/client"))
    ) {
      void router.navigateByUrl("/access-denied");
      return false;
    }

    if (
      user.type === "CLIENT" &&
      (state.url.startsWith("/admin") || state.url.startsWith("/nurse"))
    ) {
      void router.navigateByUrl("/access-denied");
      return false;
    }

    // Permission check (route-level)
    const userPermissions: string[] = Array.isArray(user.permissions)
      ? user.permissions
      : [];
    const requiredPermissions: string[] = route.data?.["permissions"] || [];

    const hasPermission = requiredPermissions.every((permission: string) =>
      userPermissions.includes(permission),
    );

    if (!hasPermission) {
      void router.navigate(["access-denied"]);
      return false;
    }

    return true;
  } catch {
    authService.clearClientAuthStateWithoutServerCall();
    void router.navigateByUrl("/welcome", { replaceUrl: true });
    return false;
  }
};
